import 'app/routes/index.css.ts.vanilla.css?source=LnJvdXRlc19oZWFkZXJfXzE4Y3g3NjgwIHsKICBmb250LWZhbWlseTogc3lzdGVtLXVpLCBzYW5zLXNlcmlmOwogIGxpbmUtaGVpZ2h0OiAxLjU7Cn0=';
export var header = 'routes_header__18cx7680';